import { render, staticRenderFns } from "./BadgeListSlot.vue?vue&type=template&id=091456e9&"
import script from "./BadgeListSlot.vue?vue&type=script&lang=js&"
export * from "./BadgeListSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports